import { UPDATE_PROFIT_BY_STORE_WIDGET } from "./actionTypes"

export const updateProfitByStoreWidget = data => {
  return {
    type: UPDATE_PROFIT_BY_STORE_WIDGET,
    payload: data,
  }
}
